import { render, staticRenderFns } from "./WordModal.vue?vue&type=template&id=3870511a&scoped=true"
import script from "./WordModal.vue?vue&type=script&lang=js"
export * from "./WordModal.vue?vue&type=script&lang=js"
import style0 from "./WordModal.vue?vue&type=style&index=0&id=3870511a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870511a",
  null
  
)

export default component.exports